module.exports = __webpack_public_path__ + "img/dropsBanner_900.adaad52e.png";